import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const common: AppRouteModule = {
  path: '/common',
  name: 'Common',
  component: LAYOUT,
  meta: {
    icon: '',
    title: t('routes.nurse.detailPage'),
    hideMenu: true,
  },
  children: [
    {
      path: 'sleep-monitor',
      name: 'SleepMonitor',
      component: () => import('/@/views/nurse/common/sleep-monitor/index.vue'),
      meta: {
        icon: '',
        title: t('routes.nurse.sleepMonitor'),
      },
    },
    {
      path: 'fall-monitor',
      name: 'FallMonitor',
      component: () => import('/@/views/nurse/common/fall-monitor/index.vue'),
      meta: {
        icon: '',
        title: t('routes.nurse.fallMonitor'),
      },
    },
  ],
};

export default common;
